module.exports = __webpack_public_path__ + "static/media/14_Case Management.3b8fdf70.jpg";